/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import UserModel from 'cio/models/user';
import EnvironmentModel from 'cio/models/environment';
import searchByProperty from 'cio/utils/search-by-property';

const ENABLE_SEARCH_AFTER = 5;

interface SettingsTeamMembersTableArgs {
  users: UserModel[];
  currentUser: UserModel;
  environments: EnvironmentModel[];
  resetPasswordAction: () => Promise<void>;
  onUpdateSubmit: () => Promise<void>;
  onDelete: () => Promise<void>;
  dontAllowAdminRemoval: boolean;
}

export default class SettingsTeamMembersTable extends Component<SettingsTeamMembersTableArgs> {
  @tracked searchTerm = '';

  get searchEnabled() {
    return this.args.users.length > ENABLE_SEARCH_AFTER;
  }

  get filteredUsers() {
    return searchByProperty(this.args.users, ['fullName', 'email'], this.searchTerm.trim());
  }
}
